/* hs-eslint ignored failing-rules */
/* eslint-disable prefer-promise-reject-errors */

import { createApiCache, MAX_CACHE_TIMEOUT } from './createApiCache';
import { ApiMap } from '../ApiMap';
const BrandFontsCache = {};
export function getFetchBrandingCustomFonts(http) {
  const withBrandFonts = createApiCache(http.get, ApiMap.BRAND_FONTS.getUrl, BrandFontsCache, MAX_CACHE_TIMEOUT);
  return function fetchBrandingFonts() {
    return withBrandFonts();
  };
}